import { PaymentStatus, SubscriptionStatus } from '@prisma/client';
import {
  CALLOUT_TEXTS,
  DIALOG_TITLES,
  MESSAGES
} from '../../constants/messages';

export const urlToStep = new Map([
  ['subscribe', 1],
  ['registration', 2],
  ['payment', 3]
]);

export const StepToLabel = new Map([
  [1, 'Выберите план подписки'],
  [2, 'Зарегистрируйтесь на портале'],
  [3, 'Оплатите подписку'],
  [4, 'Успешная активация подписки']
]);

export function getLabelByStep(step: number) {
  const label = StepToLabel.get(step);
  if (!label) throw new Error('Неподдерживаемое значение шага');
  return label;
}

export const routeToMessage = new Map([
  [
    'premium',
    'Для продолжения просмотра полного текста решения задачи необходимо авторизоваться.'
  ],
  [
    'profile',
    'Для продолжения работы в Личном кабинете необходимо авторизоваться.'
  ]
]);

export function getMessageByRoute(route: string | undefined) {
  if (!route) return 'Требуется авторизация.';

  const message = routeToMessage.get(route);

  if (!message) return 'Требуется авторизация.';
  return message;
}
export const errorClassToDialogTitle = new Map([
  ['UserAlreadyExistsError', DIALOG_TITLES.userSubscribed],
  ['SessionNotFoundError', DIALOG_TITLES.signUpSessionExpired]
]);

export function getDialogTitleByErrorClass(errorClass: string) {
  if (!errorClass) return 'Неизвестная ошибка';

  const title = errorClassToDialogTitle.get(errorClass);

  if (!title) return 'Неизвестная ошибка';
  return title;
}

export const errorClassToDialogMessage = new Map([
  ['UserAlreadyExistsError', MESSAGES.userSubscribed],
  ['SessionNotFoundError', MESSAGES.signUpSessionExpired]
]);

export function getDialogMessageByErrorClass(errorClass: string) {
  if (!errorClass) return 'Неизвестная ошибка';

  const title = errorClassToDialogMessage.get(errorClass);

  if (!title) return 'Неизвестная ошибка';
  return title;
}

export const errorClassToConfirmButtonMessage = new Map([
  ['UserAlreadyExistsError', 'Войти'],
  ['SessionNotFoundError', 'Вернуться к началу оформления подписки']
]);

export function getConfirmButtonMessageByErrorClass(errorClass: string) {
  if (!errorClass) return 'ОК';

  const title = errorClassToConfirmButtonMessage.get(errorClass);

  if (!title) return 'ОК';
  return title;
}

export const subscriptionAllInStatusToMessage = new Map([
  [true, CALLOUT_TEXTS.allInSubscription],
  [false, CALLOUT_TEXTS.allInSubscription]
]);

export function getMessageBysubscriptionAllInStatus(allIn: boolean) {
  const message = subscriptionAllInStatusToMessage.get(allIn);

  return message;
}

export const paymentStatusToSubscriptionStatus = new Map([
  [PaymentStatus.PENDING, SubscriptionStatus.PENDING],
  [PaymentStatus.SUCCEEDED, SubscriptionStatus.SUBSCRIBED],
  [PaymentStatus.CANCELED, SubscriptionStatus.UNSUBSCRIBED]
]);

export function getSubscriptionStatusByPaymentStatus(
  paymentStatus: PaymentStatus
) {
  const subscriptionStatus =
    paymentStatusToSubscriptionStatus.get(paymentStatus);
  if (!subscriptionStatus)
    throw new Error('Неподдерживаемое значение статуса платежа');
  return subscriptionStatus;
}
